export const contactsData = {
    email: 'das10arijit@gmail.com',
    phone: '+91 8697832431',
    address: 'Kolkata, India',

    sheetAPI: ''
}